import { Component, HostBinding, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'upsc-delivery-defense-score-information-dialog',
    templateUrl: './delivery-defense-score-information-dialog.component.html',
    styleUrls: ['./delivery-defense-score-information-dialog.component.scss'],
})
export class DeliveryDefenseScoreInformationDialogComponent {
    @HostBinding('class') public hostClass = 'delivery-defense-score-information-dialog';

    public scores = [
        { range: '100-299', riskMultiplier: 16 },
        { range: '300-499', riskMultiplier: 13 },
        { range: '500-699', riskMultiplier: 9 },
        { range: '700-799', riskMultiplier: 4 },
        { range: '800-1000', riskMultiplier: 0 },
    ];
    public maxRange: string;

    constructor(public dialogRef: MatDialogRef<DeliveryDefenseScoreInformationDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.maxRange = this.scores.slice(-1)?.[0]?.range || '800-1000';
    }
}
